import React from "react";
import PathConstants from "./pathConstants";

const AccountOverview = React.lazy(
  () => import("../pages/Product/Account/AccountOverview"),
);

const routes = [
  { path: PathConstants.AccountOverview, element: <AccountOverview /> },
];

export default routes;
